import script from "./withdrawalAddressPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./withdrawalAddressPopup.vue?vue&type=script&setup=true&lang=js"

import "./withdrawalAddressPopup.vue?vue&type=style&index=0&id=0d29b0a5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d29b0a5"]])

export default __exports__